<template lang="pug">
  .content
    .content__block.content-about.ql-editor(
      v-html="description"
    )
</template>

<script>
import {VueEditor} from "vue2-editor";

export default {
  name: "CampAbout",
  components: {
    VueEditor
  },
  props: {
    description: {
      type: String,
      default: ""
    }
  }

};
</script>
